module.exports = __webpack_public_path__ + "img/edge_divers_marche.720458b5.svg";